import { Component, OnInit, Input } from '@angular/core';
import { MainserviceService } from '../service/mainservice.service';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { CourseMaster } from '../model/CourseMaster.model';
MainserviceService
@Component({
  selector: 'app-student-enroll',
  templateUrl: './student-enroll.component.html',
  styleUrls: ['./student-enroll.component.scss']
})

export class StudentEnrollComponent implements OnInit {
  @Input() enrollCourseMaster:EnrollCourseMaster = new EnrollCourseMaster();
  cities: any[];

    selectedCity: any;
  constructor(private mainService:MainserviceService) { }

  ngOnInit() {
    this.cities = [
      {name: 'New York', code: 'NY'},
      {name: 'Rome', code: 'RM'},
      {name: 'London', code: 'LDN'},
      {name: 'Istanbul', code: 'IST'},
      {name: 'Paris', code: 'PRS'}
  ];
  }

}
